import gql from 'graphql-tag';

const ORG_LIST_FRAGMENT: string = `
    id
    title
    description
    users_aggregate {
        aggregate {
            count
        }
    }
`;


const Q_GET_ORGANIZATIONS = gql`
    query GetOrg($org_id: uuid) {
        organizations(
            where: {
            _and: [
                { id: { _eq: $org_id } }
            ]},
            order_by: { description: desc }
        ) {
            ${ORG_LIST_FRAGMENT}
        }
    } 
`;

const Q_GET_ORGANIZATION_LIST = gql`
    query GetOrg($org_id: uuid) {
        organizations(
            where: {
            _and: [
                { id: { _eq: $org_id } }
            ]},
            order_by: { description: desc }
        ) {
            id
            title
            description
        }
    } 
`;


export {
    Q_GET_ORGANIZATION_LIST,
    Q_GET_ORGANIZATIONS,
}




